module.exports = __webpack_public_path__ + "static/img/2-3-2.4de7473c.jpg";